import React from 'react';
import { useRecoilValue } from 'recoil';
import { Menu, PopoverOrigin, PopoverReference } from '@mui/material';
import useContextMenu from 'hooks/useContextMenu';
import contextMenu from 'recoil/atoms/contextMenu';


const position: PopoverOrigin = {
    vertical: 'top',
    horizontal: 'right',
};

const AutoContextMenu = () => {
    const context = useRecoilValue(contextMenu);
    const {closeMenu} = useContextMenu();

    const buttonAnchor = context?.anchorEl ? {
        anchorEl: context.anchorEl,
        anchorOrigin: position,
        transformOrigin: position,
    } : {};

    const mouseAnchor = context?.position ? {
        anchorReference: 'anchorPosition' as PopoverReference,
        anchorPosition: context.position
    } : {};

    return (
        <Menu
            id="context-menu"
            {...buttonAnchor}
            {...mouseAnchor}
            open={context?.open || false}
            onClose={closeMenu}
            slotProps={{
                root: {
                    onContextMenu: e => {
                        e.preventDefault();
                        closeMenu();
                    },
                },
            }}
        >
            {context?.itemsRenderer?.({
                value: context!.value,
                close: closeMenu,
                open: context!.open,
            })}
        </Menu>
    );
};

export default AutoContextMenu;
